import React from "react";
import { Route, Switch } from "react-router-dom";
import PrimaryTheme from "../../Themes/Primary";
import ErrorPage from "../../routes/ErrorPage/ErrorPage";
import LandingPage from "../../routes/LandingPage/LandingPage";
import { Backdrop, createStyles, makeStyles, Theme } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Reducers } from "../../Interfaces/Interfaces";
import Spinner from "../../components/Spinner";
import ResetPassword from "../../routes/ResetPassword/ResetPassword";
import PasswordUpdate from "../../routes/PasswordUpdate/PasswordUpdate";
import ConfirmEmail from "../../routes/ConfirmEmail/ConfirmEmail";
import AggregatorInvite from "../../routes/Aggregators/aggregatorInvite";

export default function OpenLayout() {
  const classes = useStyles();
  const loading = useSelector((state: Reducers) => state.loading);

  return (
    <div className="bg-white">
      {/* <OpenAppBar /> */}

      <div className="" style={{ backgroundColor: PrimaryTheme.background }}>
        <Switch>
          <Route exact strict path="/">
            <LandingPage />
          </Route>

          <Route exact strict path="/account/reset">
            <ResetPassword />
          </Route>

          <Route exact strict path="/account/email-confirmation">
            <ConfirmEmail />
          </Route>

          <Route exact strict path="/account/update-password">
            <PasswordUpdate />
          </Route>
          <Route exact strict path="/invite">
            <AggregatorInvite />
          </Route>

          {/* 
            <Route exact strict path='/get-started'>
              <SignUp />
            </Route>

            <Route exact strict path='/forgot-password'>
              <ForgotPassword />
            </Route>

            <Route exact strict path='/reset-password/:token'>
              <ResetPassword />
            </Route>

            <Route exact strict path='/unauthorized'>
              <Unauthorized />
            </Route> */}

          <Route exact strict path="*">
            <ErrorPage />
          </Route>
        </Switch>

        <Backdrop className={classes.backdrop} open={loading}>
          <Spinner />
        </Backdrop>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      // zIndex: theme.zIndex.drawer + 4,
      zIndex: 5000,
      color: "#fff",
    },
    option: {
      fontSize: 15,
      "& > span": {
        marginRight: 10,
        fontSize: 18,
      },
    },
  })
);
